<div class="hpanel" *ngFor="let data of interactionResponse; let i = index">
  <div class="panel-body pad-0 border-radius-top-left-right-6 border-radius-bottom-left-right-6">
    <div class="three-column-actions-labels492" [ngClass]="{ 'disabled': disableCard(data)}">
      <div class="firstRow638">
        <div class="statusBtn265">
          <!-- no interaction then just show the label  -->
          <div class="btn-group729 pull-right" *ngIf="!showInteractiveButton" dropdown>
            <button id="NOT_INTERACTIVE" data-toggle="dropdown" class="btn-sm438 dropdown-toggle743 cursor-con-menu"
              [ngStyle]="getStyle(data?.currentStatus)" aria-expanded="true">
              <ng-container> {{ getFilterValue(data?.currentStatus) | titlecase }} </ng-container>
            </button>
          </div>

          <!-- CDI for RECRUITER ACTION -->
          <div class="btn-group729" dropdown id="jb_dpDown" *ngIf="showInteractiveButton && contentType === 'CDI'">
            <!-- remaining screens and candidate invited widgets  -->
            <ng-container *ngIf="cardContent === 'DEFAULT'">
              <button data-toggle="dropdown" dropdownToggle id="CDI_DEFAULT"
                [class.addExtraPaddingRight]="!isExcludedStatus(data?.currentStatus)"
                class="btn-sm438 dropdown-toggle743" aria-expanded="true" [ngStyle]="getStyle(data?.currentStatus)">
                <div> {{ getFilterValue(data?.currentStatus) | titlecase }}</div>
                <div *ngIf="!isExcludedStatus(data?.currentStatus)">
                  <ng-icon name="tablerChevronDown" class="arrowclass916" aria-hidden="true"></ng-icon>
                </div>
              </button>
              <ng-container *ngIf="!isExcludedStatus(data?.currentStatus)">
                <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu" role="menu"
                  aria-labelledby="button-animated">
                  <li role="menuitem" *ngFor="let statusData of filterApplicant(data?.currentStatus, data?.nextAllowedStatuses)"
                    [class.gs-status-locked]="isStatusLocked(statusData)"
                    [attr.aria-disabled]="isStatusLocked(statusData) ? true : null"
                    [attr.title]="isStatusLocked(statusData) ? 'Managed from Contract Manager' : null"
                    (click)="isStatusLocked(statusData) ? $event.stopPropagation() : validateNegativeStatus(statusData , data, interviewPayrateTemplate)" id="{{statusData?.item}}">
                    <a id="{{statusData?.item}}"><ng-icon name="tablerCircle" class="fs-status-icon" aria-hidden="true"></ng-icon>&nbsp;
                      {{statusData?.item}}
                    </a>
                  </li>
                </ul>
              </ng-container>
            </ng-container>

            <!-- for resume requst received widget -->
            <ng-container *ngIf="cardContent === 'CDI'">
              <button id="CDI" type="button" [ngClass]="{'green-btn': data?.currentStatus=='COMPLETED'}" class="btn-sm438 dropdown-toggle743"
                *ngIf="data?.candidateEntity.status=='ACTIVE'&& data?.currentStatus!='RESUME_UPDATED' && data?.currentStatus!='COMPLETED'"><ng-icon name="tablerPaperclip"></ng-icon>
                Attach Resume</button>
              <button type="button" class="btn-sm438 dropdown-toggle743 cursor-con-menu" disabled
                *ngIf="data?.currentStatus=='COMPLETED'">Resume
                attached</button>
            </ng-container>

            <!-- for resume request sent widget  -->
            <ng-container *ngIf="cardContent === 'RESUME_SENT'">
              <button id="CDI" type="button" [ngStyle]="getStyle('RESUME-PENDING')" disabled
                class="btn-sm438 dropdown-toggle743 cursor-con-menu" *ngIf="data?.currentStatus === 'INITIATED'">
                Resume pending </button>
              <button type="button" class="btn-sm438 dropdown-toggle743 cursor-con-menu"
                *ngIf="data?.currentStatus === 'COMPLETED'"> Resume attached</button>
            </ng-container>
          </div>

          <!-- JA for BENCH_SALE ACTION -->
          <div class="btn-group729" dropdown id="jb_dpDown" *ngIf="showInteractiveButton && contentType === 'JA'">
            <!-- remaining screens and job invited recieved widgets  -->
            <ng-container *ngIf="cardContent === 'DEFAULT'">
              <button data-toggle="dropdown" dropdownToggle id="JA_DEFAULT"
                [class.addExtraPaddingRight]="data?.currentStatus == 'INITIATED'" class="btn-sm438 dropdown-toggle743"
                aria-expanded="true" [ngStyle]="getStyle(data?.currentStatus)">


                <ng-container> {{ getFilterValue(data?.currentStatus) | titlecase }} </ng-container>
                <ng-icon name="tablerChevronDown" class="arrowclass916" *ngIf="!isExcludedStatus(data?.currentStatus)" 
                  aria-hidden="true"></ng-icon>
              </button>

              <ng-container *ngIf="!isExcludedStatus(data?.currentStatus)">
                <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu" role="menu"
                  aria-labelledby="button-animated">
                  <li role="menuitem" *ngFor="let statusData of filterApplicant(data?.currentStatus, data?.nextAllowedStatuses)"
                    [class.gs-status-locked]="isStatusLocked(statusData)"
                    [attr.aria-disabled]="isStatusLocked(statusData) ? true : null"
                    [attr.title]="isStatusLocked(statusData) ? 'Managed from Contract Manager' : null"
                    (click)="isStatusLocked(statusData) ? $event.stopPropagation() : updatestatusFor(statusData.itemId , data , RTRtemplate)" id="{{statusData?.item}}"> <a> <ng-icon name="tablerCircle" class="fs-status-icon t-active" aria-hidden="true"></ng-icon> {{statusData?.item}} </a>
                  </li>
                </ul>
              </ng-container>
            </ng-container>

            <!-- cardContent JA will be for Job Applied  -->
            <!-- [class.width14]="data?.currentStatus === 'INTERVIEW-SCHEDULED' || data?.currentStatus === 'PREONBOARDED'" -->
            <ng-container *ngIf="cardContent === 'JA'">
              <button id="JA" data-toggle="dropdown" dropdownToggle class="btn-sm438 dropdown-toggle743"
                aria-expanded="true" [ngStyle]="getStyle(data?.currentStatus)">
                <ng-container> {{ getFilterValue(data?.currentStatus) | titlecase }} </ng-container>
                <ng-icon name="tablerChevronDown" *ngIf="!isExcludedStatusTwo(data?.currentStatus)"  aria-hidden="true"></ng-icon>
              </button>

              <ng-container *ngIf="!isExcludedStatusTwo(data?.currentStatus)">
                <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu custom-margin" role="menu"
                  aria-labelledby="jb_dpDown">
                  <li role="menuitem" *ngFor="let statusData of filterApplicant(data?.currentStatus, data?.nextAllowedStatuses)"
                    [class.gs-status-locked]="isStatusLocked(statusData)"
                    [attr.aria-disabled]="isStatusLocked(statusData) ? true : null"
                    [attr.title]="isStatusLocked(statusData) ? 'Managed from Contract Manager' : null"
                    (click)="isStatusLocked(statusData) ? $event.stopPropagation() : updatestatuswithdraw(statusData , data)" id="{{statusData?.item}}">
                    <a id="{{statusData?.item}}"><ng-icon name="tablerCircle" class="fs-status-icon" aria-hidden="true"></ng-icon>&nbsp;
                      {{statusData?.item}}
                    </a>
                  </li>
                </ul>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
      <div id="RESUME_REQUEST" *ngIf="cardContent === 'RESUME_REQUEST_RECIEVED'">
        <button id="attachResume" type="button" class="btn-sm438 dropdown-toggle743" (click)="model(data,template,i)"
          *ngIf="data?.candidateEntity.status=='ACTIVE'&& data?.currentStatus!='RESUME_UPDATED' && data?.currentStatus!='COMPLETED'"><ng-icon name="tablerPaperclip"></ng-icon>
          Attach Resume</button>
        <button type="button"  [ngClass]="{'green-btn': data?.currentStatus=='COMPLETED'}" class="btn-sm438 dropdown-toggle743 cursor-con-menu" disabled
          *ngIf="data?.currentStatus=='COMPLETED'">  Resume Attached</button>
      </div>
    </div>
    <div class="row-container238" [ngClass]="{ 'disabled': disableCard(data)}">
      <div class="profiles374" *ngIf="contentType === 'CDI'">
        <div class="profile-image761">
          <div *ngIf="isValidPhoto(data)">
            <img [src]="getPhotoUrl(data?.user?.photo)" alt="profile-picture" (error)="onImageError(data)">
          </div>
          <div *ngIf="!isValidPhoto(data)">
            <div class="circles487" [style.background-color]="getColor(data?.user?.firstName, data?.user?.lastName)">
              <div class="circle-text" [style.color]="getTextColor(data?.user?.firstName, data?.user?.lastName)">{{
                getInitials(data?.user?.firstName, data?.user?.lastName) }}</div>
            </div>
          </div>
          <div class="userType593">{{data?.user?.userType.substring(0,2)}}</div>
        </div>
        <div class="username728" [title]="(data?.user?.firstName + ' ' + data?.user?.lastName)" > {{ (data?.user?.firstName + " " + data?.user?.lastName) }} </div>
        <div class="three-column-timestamp374">{{ data?.user?.createdOn | timezoneDate:'MM/dd/yyyy'}}</div>
      </div>

      <div id="CDI" class="flex-user-profile683 cursor-pointer" *ngIf="contentType === 'CDI'&&data?.jobDetails">
        <div (click)="route(data,'applied','directRoute')">
          <div class="job-content493">
            <div class="heading-section284">
              <div>
                <ng-icon name="tablerBriefcase" class="title-svg mr-rt-5"></ng-icon>
              </div>
              <div class="title-ellipse482" [title]="data.jobDetails?.jobTitle">
                {{data.jobDetails?.jobTitle}}
              </div>
            </div>
            <div style="font-weight: initial;" class="job-closed-tag485" [ngStyle]="getStyle('INACTIVE')"
              *ngIf="data?.jobDetails?.status !== 'ACTIVE' || !data?.jobDetails?.availability">
              {{ data?.jobDetails?.status !== 'ACTIVE' ? convertSmallCase(data?.jobDetails?.status) : 'On Hold' }}
            </div>
          </div>

          <div class="three-column-experience928">
            Experience : {{ data.jobDetails?.experienceFrom}} to {{data.jobDetails?.experienceTo }}
            Years
          </div>

          <div class="clientDetailList583"
            title=" {{data.jobDetails?.clientType}}, {{data.jobDetails?.city}}, {{data.jobDetails?.state}} ">
            <div class="mb-5" title="{{data.jobDetails?.clientName}}" *ngIf="data.jobDetails?.showClientName">
              <ng-icon name="tablerBuilding" class="svg-position172"></ng-icon>
              {{data.jobDetails?.clientName | truncate:20}}
            </div>
            <div class="mb-5" *ngIf="data.jobDetails?.showClientType">
              <ng-icon name="tablerBriefcase" class="svg-position172"></ng-icon>
              {{data.jobDetails?.clientType}}
            </div>
            <div class="mb-5">
              <ng-icon name="tablerMapPin" class="svg-position172" *ngIf="data.jobDetails?.city || data.jobDetails?.state"></ng-icon>
              {{data.jobDetails?.city}}
              <span *ngIf="data.jobDetails?.state">,</span> {{data.jobDetails?.state}}
            </div>

            <div class="mb-5">
              <ng-icon name="tablerBriefcase" title="{{data.jobDetails?.jobClassification}}" class="svg-position172"></ng-icon>
              {{data.jobDetails?.jobClassification}}
            </div>
            <div class="mb-5">
              <ng-container *ngIf="data?.jobDetails?.targetRateFrom && data?.jobDetails?.targetRateTo; else noRateCDI">
                <span
                  title="{{data?.jobDetails?.targetRateFrom}} - {{data?.jobDetails?.targetRateTo}}">{{data?.jobDetails?.targetRateFrom}}
                  - {{data?.jobDetails?.targetRateTo}}</span>
              </ng-container>
              <ng-template #noRateCDI><span title="Employer estimate: Not available">$ Not available</span></ng-template>
            </div>
            <div class="mb-5"
              *ngIf="(data?.jobDetails?.country!=null || data?.jobDetails?.source === 'CEIPAL') && data?.jobDetails?.targetRateFrom && data?.jobDetails?.targetRateTo">
              <span title="{{data?.jobDetails?.source === 'CEIPAL' ? (getJobCurrency(data?.jobDetails) + ' /') : getCountryValue(data?.jobDetails?.country)}}">
                {{data?.jobDetails?.source === 'CEIPAL' ? (getJobCurrency(data?.jobDetails) + ' /') : getCountryValue(data?.jobDetails?.country)}}</span>
              <span title="{{getPaytype(data?.jobDetails?.payType)}}">
                {{getPaytype(data?.jobDetails?.payType)}}
              </span>
            </div>

            <div *ngIf="data.jobDetails?.workMode=='Onsite'" class="mb-5" title="Onsite">
              <ng-icon name="tablerMapPin" class="svg-position172"></ng-icon>
              Onsite
            </div>
            <div *ngIf="data.jobDetails?.workMode=='Remote'" class="mb-5" title="Remote">
              <ng-icon name="tablerMapPin" class="svg-position172"></ng-icon>
              Remote
            </div>
            <div *ngIf="data.jobDetails?.workMode=='Hybrid'" class="mb-5" title="Hybrid">
              <ng-icon name="tablerMapPin" class="svg-position172"></ng-icon>
              Hybrid
            </div>
          </div>
        </div>
      </div>

      <div id="CDI" class="flex-user-profile683 cursor-pointer" *ngIf="contentType === 'CDI'&&!data?.jobDetails">
      </div>

      <div id="JA_profiles" class="profiles374" *ngIf="contentType === 'JA'">
        <div class="profile-image761">
          <div *ngIf="isValidPhoto(data)">
            <img [src]="getPhotoUrl(data?.user?.photo)" alt="profile-picture" (error)="onImageError(data)">
          </div>
          <div *ngIf="!isValidPhoto(data)">
            <div class="circles487" [style.background-color]="getColor(data?.user?.firstName, data?.user?.lastName)">
              <div class="circle-text" [style.color]="getTextColor(data?.user?.firstName, data?.user?.lastName)">{{
                getInitials(data?.user?.firstName, data?.user?.lastName) }}</div>
            </div>
          </div>
          <div class="userType593">{{data?.user?.userType.substring(0,2)}}</div>
        </div>
        <div class="username728" [title]="(data?.user?.firstName + ' ' + data?.user?.lastName)"> {{ (data?.user?.firstName + " " + data?.user?.lastName) }} </div>
        <div class="three-column-timestamp374">{{ data?.user?.createdOn | timezoneDate:'MM/dd/yyyy'}}</div>
      </div>

      <div id="JA" class="flex-user-profile683 cursor-pointer" *ngIf="contentType === 'JA'">
        <div (click)="route(data,'applied', 'directRoute')">
          <div class="job-content493">
            <div class="heading-section284">
              <div>
                <ng-icon name="tablerUser" class="svg-position172"></ng-icon>
              </div>
              <div class="title-ellipse482"
                title="{{data.candidateEntity?.firstName|titlecase}} {{ data.candidateEntity?.lastName|titlecase}}">
                {{data.candidateEntity?.firstName|titlecase}} {{ data.candidateEntity?.lastName|titlecase}}
              </div>
            </div>
            <div style="font-weight: initial;" class="job-closed-tag485" [ngStyle]="getStyle('INACTIVE')"
              *ngIf="CIshouldShowStatusText(data)">
              {{ getStatusText(data) }}
            </div>
          </div>
          <div class="three-column-experience928">
            Experience : {{ data?.candidateEntity?.totalExperience}} Years
          </div>

          <div class="clientDetailList583" title="{{data.candidateEntity?.city}}, {{data.candidateEntity?.state}} ">
            <div class="mb-5">
              <ng-icon name="tablerMapPin" *ngIf="data.candidateEntity?.city || data.candidateEntity?.state"
                class="svg-position172"></ng-icon>
              {{data?.candidateEntity?.city}}
              <span *ngIf="data.candidateEntity?.state">,</span> {{data.candidateEntity.state}}
            </div>

            <div class="mb-5">
              <ng-icon name="tablerCurrencyDollar" class="svg-position172"></ng-icon>
              <ng-container
                *ngIf="data?.candidateEntity?.targetRateFrom && data?.candidateEntity?.targetRateTo; else noRateJA">
                <span title="{{data?.candidateEntity?.targetRate}}">{{data?.candidateEntity?.targetRateFrom}} -
                  {{data?.candidateEntity?.targetRateTo}}</span>
              </ng-container>
              <ng-template #noRateJA><span title="Rate: Not available">Not available</span></ng-template>
            </div>
            <div class="mb-5"
              *ngIf="data?.candidateEntity?.country!=null && data?.candidateEntity?.targetRateFrom && data?.candidateEntity?.targetRateTo">
              <span title="{{getCountryValue(data?.candidateEntity?.country)}}">
                {{getCountryValue(data?.candidateEntity?.country)}}</span>
              <span title="{{getPaytype(data?.candidateEntity?.payType)}}">
                {{getPaytype(data?.candidateEntity?.payType)}}
              </span>
            </div>
            <div *ngIf="data.candidateEntity?.workMode=='Onsite'" class="mb-5" title="Onsite">
              <ng-icon name="tablerMapPin" class="svg-position172"></ng-icon>
              Onsite
            </div>
            <div *ngIf="data.candidateEntity?.workMode=='Remote'" class="mb-5" title="Remote">
              <ng-icon name="tablerMapPin" class="svg-position172"></ng-icon>
              Remote
            </div>
            <div *ngIf="data.candidateEntity?.workMode=='Hybrid'" class="mb-5" title="Hybrid">
              <ng-icon name="tablerMapPin" class="svg-position172"></ng-icon>
              Hybrid
            </div>
          </div>
        </div>
      </div>
      <div class="perpendicular-line"></div>

      <div class="flex-candidate293">
        <div class="candidate-content182">
          <div class="space-bt-flex763">
            <div class="display-flex928">
              <ng-icon name="tablerUser" *ngIf="contentType === 'CDI'; else suitcase" class="title-svg"></ng-icon>
              <ng-template #suitcase>
                <ng-icon name="tablerBriefcase" *ngIf="data.jobDetails!=undefined" class="title-svg mr-rt-5"></ng-icon>
              </ng-template>
              <div class="candidateName382 text-ellipse482" title="{{ getData(data , 'firstRow')}}"> {{ getData(data ,
                'firstRow')}} </div>
            </div>
            <div class="status-12">
              <div style="font-weight: initial;" class="job-closed-tag485" [ngStyle]="getStyle('INACTIVE')"
                *ngIf="shouldShowStatusText(data)">
                {{ getStatusText(data) }}
              </div>
              <div style="font-weight: initial;" class="job-closed-tag485" [ngStyle]="getStyle('INACTIVE')"
                *ngIf="(data?.jobDetails&&data?.jobDetails?.status !== 'ACTIVE' || data?.jobDetails&&!data?.jobDetails?.availability) && contentType != 'CDI'">
                {{ data?.jobDetails?.status !== 'ACTIVE' ? convertSmallCase(data?.jobDetails?.status) : 'On Hold' }}
              </div>
            </div>
          </div>
          <div>
            <ng-icon name="tablerMapPin" *ngIf="getData(data , 'secondRow')" class="svg-position172"></ng-icon>
            {{getData(data , 'secondRow')}}
          </div>
          <div class="flex-3rem921">
            <div>{{getData(data , 'EXP')}}</div>
          </div>
          <!-- <div class="primary274">
            <div class="skills837" *ngFor="let items of getData(data,'primarySkills')">
              <div title="{{items}}">
                {{items | truncate: 14}}
              </div>
            </div>
          </div> -->

          
          <div class="primary274">
  <div class="skills837" *ngFor="let items of getVisibleSkills(data)">
    <div title="{{items}}">
      {{items | truncate: 14}}
    </div>
  </div>

  <div class="skills837 show-more-chip"
       *ngIf="getData(data,'primarySkills')?.length > 3"
       (click)="toggleSkills(data, $event)">
    {{ isSkillsExpanded(data) ? 'Show less' : '+' + (getData(data,'primarySkills').length - 3) + ' more' }}
  </div>
</div>
        </div>
      </div>
    </div>

    <div class="bottom-row-container463" [ngClass]="{ 'disabled': disableCard(data)}">
      <div class="three-column-card-interactive-element-container764" *ngIf="contentType === 'CDI'&&data?.jobDetails">
        <div class="bottom-data827">
          <div title="{{data?.jobDetails?.viewedByCount}} Views" (click)="route(data,'views')" class="cursor">
            <ng-icon name="tablerEye"
              [ngClass]="{'icon-prime-color': data?.jobDetails?.viewedByCount >= 0, 'blue-color': data?.jobDetails?.viewedByCount > 0}"></ng-icon>
            <span [ngClass]="{'blue-color': data?.jobDetails?.viewedByCount >= 0}">
              {{ data?.jobDetails?.viewedByCount | compactCount }}</span>
            <span>
              Views
            </span>
          </div>
          <!-- like section -->
          <div title="{{data?.jobDetails?.likesCount}} Likes" (click)="route(data, 'likes')">
            <ng-icon name="tablerHeart" [ngClass]="(!data?.jobDetails?.isLiked || null) ? 'pointer icon-prime-color' : 'liked pointer bg-heart'"
              (click)="likes(data?.jobDetails, 'job')"></ng-icon>
            <span [ngClass]="{'blue-color': data?.jobDetails?.likesCount >= 0}">
              {{ data?.jobDetails?.likesCount | compactCount }}</span>
            <span>
              Likes
            </span>
          </div>
          <!-- applied / invite section  -->
          <div title="{{data.jobDetails?.appliedCount}} Applied" *ngIf="data.jobDetails?.jobPostedBy == userId"
            (click)="route(data,'applied')">
            <ng-icon name="tablerSend" class="icon-prime-color"></ng-icon>
            <span [ngClass]="{'blue-color' : data?.jobDetails?.appliedCount >=0}">{{ data.jobDetails?.appliedCount | compactCount }}</span> Applied
          </div>

          <div title="{{data.jobDetails?.interestShownCount}} Invites" *ngIf="data.jobDetails?.jobPostedBy==userId"
            (click)="route(data,'invited')">
            <ng-icon name="tablerUsers" class="pointer icon-prime-color"></ng-icon>
            <span
              [ngClass]="{'blue-color' : data?.jobDetails?.interestShownCount >=0}">{{ data?.jobDetails?.interestShownCount | compactCount }}</span> Invites
          </div>

          <div *ngFor="let item of data?.candidateEntity?.resumes">
            <div *ngIf="item?.isDefault"> <a (click)="downloadResume(data?.candidateEntity,userId,item.fileId)"
                target="_blank" download> <ng-icon name="tablerDownload" class="icon-prime-color"></ng-icon> Download </a>
            </div>
          </div>
          <div *ngIf="data.candidateEntity.chatHistoryCount  == 0"
            (click)="openMessagecheckInteraction(data?.candidateEntity)" class="md-interaction-element"
            title="No Messages" style="cursor: context-menu;"> <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color icon-chat"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
            Chat
          </div>
          <div *ngIf="data.candidateEntity?.chatHistoryCount>0" class="chat-box-icon"
            (click)="openMessagecheckInteraction(data?.candidateEntity)"
            title="{{data.candidateEntity?.nonSeenMessageCount > 0 ? data.candidateEntity?.nonSeenMessageCount + ' Messages' : 'No Messages'}}">
           <span class="chat-icon-wrapper">
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color icon-chat" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
            <span class="noti-badge noti-chat-icon"*ngIf="data.candidateEntity?.nonSeenMessageCount>0" >{{data.candidateEntity?.nonSeenMessageCount}}</span>
             </span>
            Chat
          </div>
        </div>
      </div>
      <div class="three-column-card-interactive-element-container764" *ngIf="contentType === 'JA'">
        <div class="bottom-data827">
          <!-- view section  -->
          <div title="{{data?.candidateEntity?.viewedByCount}} Views" (click)="route(data, 'views')">
            <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon>
            <span>
              <span [ngClass]="{'blue-color': data?.candidateEntity?.viewedByCount >= 0}">{{ data?.candidateEntity?.viewedByCount | compactCount }}</span> Views
            </span>
          </div>
          <!-- like section -->
          <div title="{{data?.candidateEntity?.likesCount}} Likes" (click)="route(data,'likes')">
            <ng-icon name="tablerHeart" [ngClass]="(!data?.candidateEntity?.isLiked || null) ? 'pointer icon-prime-color' : 'liked pointer bg-heart'"
              (click)="likes(data?.candidateEntity,'candidate')"></ng-icon>
            <span>
              <span [ngClass]="{'blue-color': data?.candidateEntity?.likesCount >= 0}">{{ data?.candidateEntity?.likesCount | compactCount }}</span> Likes
            </span>
          </div>
          <!-- applied / invite section  -->
          <div title="{{data.candidateEntity?.jobsAppliedCount}} Applied"
            *ngIf="data.candidateEntity?.createdBy==userId" (click)="route(data,'applied')">
            <ng-icon name="tablerSend" class="icon-prime-color"></ng-icon>
            <span
              [ngClass]="{'blue-color': data.candidateEntity?.jobsAppliedCount >= 0}">{{ data.candidateEntity?.jobsAppliedCount | compactCount }}</span> Applied
          </div>

          <div title="{{data.candidateEntity?.interestShownCount}} Invites"
            *ngIf="data.candidateEntity?.createdBy==userId" (click)="route(data,'invited')">
            <ng-icon name="tablerMail"></ng-icon>
            <span
              [ngClass]="{'blue-color': data.candidateEntity?.interestShownCount >= 0}">{{ data.candidateEntity?.interestShownCount | compactCount }}</span> Invites
          </div>
          <!-- (click)="openMessagecheckInteraction(data?.candidateEntity)" -->
          <div *ngIf="data.candidateEntity?.chatHistoryCount == 0"
             class="md-interaction-element"
            title="No Messages" style="cursor: context-menu;"> 
              <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color icon-chat"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
            Chat
          </div>
          <div *ngIf="data?.candidateEntity?.createdBy==userId && data.candidateEntity?.chatHistoryCount>0"
            class="chat-box-icon" (click)="openMessagecheckInteraction(data?.candidateEntity)"
            title="{{data.candidateEntity?.nonSeenMessageCount > 0 ? data.candidateEntity?.nonSeenMessageCount + ' Messages' : 'No Messages'}}">
         <span class="chat-icon-wrapper">
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color icon-chat" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
            <span class="noti-badge noti-chat-icon"*ngIf="data.candidateEntity?.nonSeenMessageCount>0" >{{data.candidateEntity?.nonSeenMessageCount}}</span>
             </span>
            Chat
          </div>
        </div>
      </div>
      <div class="three-column-card-interactive-element-container764" *ngIf="contentType === 'CDI'&&!data?.jobDetails">
        <div class="job-data">
        </div>
        <div class="flex-candidate293"></div>
      </div>
    </div>
  </div>
</div>
<ng-template #RTRtemplate>

  <div class="common-header-flex">
    <div> Rate Confirmation </div>
    <button>
      <span class="common-close" (click)="hide()">&times;</span>
    </button>
  </div>

  <div class="col-sm-12 p-0 white">
    <div [formGroup]="rtrformgrp">
      <div class="RtrForm payrate-two-row">

        <div class="payrate-row">
          <div class="payrate-row-label">Submitted for</div>
          <div class="targetRate">
            <input type="text" class="form-control input-sm payrate-readonly"
                   formControlName="submittedToRate" readonly tabindex="-1" />
          </div>
          <div class="paytype">
            <select class="form-control input-sm payrate-readonly"
                    formControlName="submittedRateType" disabled tabindex="-1">
              <option value="Hourly">Hourly</option>
              <option value="Daily">Daily</option>
              <option value="Weekly">Weekly</option>
              <option value="Monthly">Monthly</option>
              <option value="Yearly">Yearly</option>
            </select>
          </div>
        </div>

        <div class="payrate-row">
          <div class="payrate-row-label">Offer for</div>
          <div class="targetRate">
            <input #rtrvalue maxlength="8" type="text" (keypress)="isInteger($event)"
              class="form-control input-sm" formControlName="offerRate" placeholder="Ex: 10000.."/>
          </div>
          <div class="paytype">
            <select formControlName="offerRateType" class="form-control input-sm">
              <option value="Hourly">Hourly</option>
              <option value="Daily">Daily</option>
              <option value="Weekly">Weekly</option>
              <option value="Monthly">Monthly</option>
              <option value="Yearly">Yearly</option>
            </select>
            <span class="error"
              *ngIf="rtrFormControls.offerRateType.errors?.required && (rtrFormControls.offerRateType?.dirty || rtrFormControls.offerRateType?.touched)">Please select pay type</span>
          </div>
        </div>

        <div class="currency">
          <ng-container *ngIf="tempdata?.jobDetails?.source !== 'CEIPAL'; else ceipalCurRtr">
          <span *ngIf="rtrformgrp.value?.country === 'US'"> USD </span>
          <span *ngIf="rtrformgrp.value?.country === 'IN'"> INR </span>
          <span *ngIf="rtrformgrp.value?.country === 'CA'"> CAD </span>
          <span *ngIf="rtrformgrp.value?.country === 'DZ'"> AUD </span>
          </ng-container>
          <ng-template #ceipalCurRtr>
            <span> {{ getJobCurrency(tempdata?.jobDetails) }} </span>
          </ng-template>
        </div>
      </div>
      <div class="pd-0-80">
        <span
          *ngIf="rtrFormControls.offerRate.errors?.required && (rtrFormControls.offerRate?.dirty || rtrFormControls.offerRate?.touched)"
          class="error">Please enter the value</span>
        <span *ngIf="rtrFormControls.offerRate.errors?.invalidDecimal" class="error">Enter valid offer rate</span>
        <span *ngIf="rtrFormControls.offerRate.errors?.max" class="error">
          Offer cannot exceed submitted ceiling of {{ rtrformgrp.get('submittedToRate')?.value }}
        </span>
      </div>
      <div class="pd-0-9-15">
        <div class="tAndCdesign">
          <!-- <input type="checkbox" class="termsCondition" formControlName="termsandcondition" id="termsCheckBox" />
               <div for="termsCheckBox">I warrant that i have an exclusive right to represent this candidate for the applied
                 position</div> -->

          <div class="custom-checkbox em">
            <label class="checkbox-label font-normal" style="text-align: center">
              I warrant that I have an exclusive right to represent this candidate for the
              applied position
              <input type="checkbox" class="termsCondition" formControlName="termsandcondition" id="termsCheckBox" />
              <span class="checkmark"></span>
            </label>
          </div>
        </div>
        <!-- <div class="t-c-error-msg"
          *ngIf="rtrFormControls.termsandcondition.invalid && (rtrFormControls.termsandcondition.touched)">
          Please accept to the above statement by checking it
        </div> -->
        <div class="t-c-error-msg"
          *ngIf="rtrFormControls.termsandcondition.invalid && (rtrFormControls.termsandcondition.touched)">
          Please acknowledge the warrant by selecting the checkbox.
        </div>
      </div>
    </div>

    <!-- <div *ngIf="showResumeUpload" class="resumeUpload"> 
        <div class="dropdox" appDnd (fileDropped)="onFileDropped($event)">
          <input style="display: none" accept=".pdf,.doc,.docx,.txt" type="file" #fileDropRef id="fileDropRef"
            (change)="fileBrowseHandler($event.target.files)" />
          <div>
            <div>
              <label class="file-boreder resumeTitle" for="fileDropRef">Upload Your Resume</label>
              <label class="file-boreder" id="aad" for="fileDropRef">Drag your files here or click in this area.</label>
            </div>
          </div>
          <div>
            <small>Only PDF, DOCX, DOC, and TXT file formats supported.</small>
          </div>
        </div>
      </div>
      <div class="files-list" *ngIf="fileDragdrop">
        <div class="single-file">
          <div class="info">
            <h4 class="name">
              {{ fileDragdrop?.name }}
            </h4>
            <p title="Download" class="cursor-pointer top-eye" (click)="onDownload()">
              <ng-icon name="tablerDownload" aria-hidden="true"></ng-icon>
            </p>
            <div (click)="removeFiles()" title="Remove File" class="tiimes">x</div>
          </div>
        </div>
      </div> -->

    <div *ngIf="showResumeUpload" class="pd-3rem">
      <div class="dropdox-908" appDnd (fileDropped)="onFileDropped($event)" for="fileDropRef">
        <input #fileDropRef style="display: none" type="file" accept=".pdf,.doc,.docx,.txt" id="fileDropRef"
          (click)="fileDropRef.value=''"
          (change)="fileBrowseHandler($event.target.files)" />

        <div class="file-icon-908">
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <line x1="12" y1="18" x2="12" y2="12"></line>
            <line x1="9" y1="15" x2="15" y2="15"></line>
          </svg>
        </div>
        <div>
          <label class="upload-title-908" for="fileDropRef">Upload Your Resume</label>
        </div>
        <div>
          <label class="upload-instruction-908" for="fileDropRef" id="aad">Drag your files here or click in this
            area.</label>
        </div>
        <div for="fileDropRef">
          <small class="upload-hint-908">Only PDF, DOCX, DOC, and TXT file formats supported.</small>
        </div>
        <div *ngIf="fileDragdrop" class="file-preview-908 file-preview-entered-908">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
            <polyline points="13 2 13 9 20 9"></polyline>
          </svg>
          <span class="file-name-908" [title]="fileDragdrop?.fileName || fileDragdrop?.name">{{fileDragdrop?.fileName || fileDragdrop?.name}}</span>
          <ng-icon name="tablerX" class="file-remove-908" (click)="removeFiles()"></ng-icon>
        </div>
      </div>
    </div>
  </div>

  <div class="custom-panel-footer col-sm-12 p-0">
    <div class="panel-footer">
      <div class="footer-flex">
        <button class="btn btn-default " (click)="hide()">Cancel </button>
        <button class="btn  btn-primary " (click)="submit()">Submit </button>
      </div>
    </div>
  </div>

</ng-template>

<ng-template #template>
  <div class="common-header-flex">
    <div> Resume Upload </div>
    <button>
      <span (click)="hideResumeModal()" class="common-close">×</span>
    </button>
  </div>
  <div class="panel-body">

    <!-- <div class="col-sm-12" style="margin-top: 17px;"> 
        <div class="dropdox-908" appDnd (fileDropped)="onFileDropped($event)" for="fileDropRef">
          <input #fileDropRef style="display: none" type="file" accept=".pdf,.doc,.docx,.txt" id="fileDropRef"
            (change)="fileBrowseHandler($event.target.files)" />
          <i class="file-icon-908"></i>
          <div>
            <label class="upload-title-908" for="fileDropRef">Upload Your Resume</label>
          </div>
          <div>
            <label class="upload-instruction-908" for="fileDropRef" id="aad">Drag your files here or click in this area.</label>
          </div>
          <div>
            <small class="upload-hint-908">Only PDF, DOCX, DOC, and TXT file formats supported.</small>
          </div>
        </div>
        <div *ngIf="fileDragdrop" class="file-preview-908 file-preview-entered-908">
          <span class="file-name-908">{{fileDragdrop?.name | truncate: 28}}</span>
          <ng-icon name="tablerX" class="svg-position file-remove-908"  (click)="removeFiles()"></ng-icon>
          <button class="file-remove-908" (click)="removeFiles()">×</button>
        </div>
      </div> -->

    <div class="col-sm-12" style="margin-top: 17px;">
      <div class="dropdox-908" appDnd (fileDropped)="onFileDropped($event)" for="fileDropRef">
        <input #fileDropRef style="display: none" type="file" accept=".pdf,.doc,.docx,.txt" id="fileDropRef"
          (click)="fileDropRef.value=''"
          (change)="fileBrowseHandler($event.target.files)" />

        <div class="file-icon-908">
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <line x1="12" y1="18" x2="12" y2="12"></line>
            <line x1="9" y1="15" x2="15" y2="15"></line>
          </svg>
        </div>
        <div>
          <label class="upload-title-908" for="fileDropRef">Upload Your Resume</label>
        </div>
        <div>
          <label class="upload-instruction-908" for="fileDropRef" id="aad">Drag your files here or click in this
            area.</label>
        </div>
        <div for="fileDropRef">
          <small class="upload-hint-908">Only PDF, DOCX, DOC, and TXT file formats supported.</small>
        </div>
        <div *ngIf="fileDragdrop" class="file-preview-908 file-preview-entered-908">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
            <polyline points="13 2 13 9 20 9"></polyline>
          </svg>
          <span class="file-name-908" [title]="fileDragdrop?.fileName || fileDragdrop?.name">{{fileDragdrop?.fileName || fileDragdrop?.name}}</span>
          <ng-icon name="tablerX" class="file-remove-908" (click)="removeFiles()"></ng-icon>
        </div>
      </div>
    </div>


    <!-- <div class="files-list" *ngIf="fileDragdrop">
        <div class="single-file">
          <div class="info">
            <h4 class="name">
              {{ fileDragdrop?.name }}
            </h4>
            <p title="Download" class="cursor-pointer top-eye" (click)="onDownload()">
              <ng-icon name="tablerDownload" aria-hidden="true"></ng-icon>
            </p>
            <div (click)="removeFiles()" title="Remove File" class="tiimes">x</div>
          </div>
        </div>
      </div> -->

  </div>

  <div class="custom-panel-footer">
    <div class="panel-footer">
      <div class="footer-flex">
        <button class="btn btn-default" (click)="hideResumeModal()">Cancel</button>
        <button class="btn  btn-primary" (click)="submitResume()">Save </button>
      </div>
    </div>
  </div>

</ng-template>




<!-- Interview Payrate Modal (for INTERVIEW-SCHEDULED / bypass stages) -->
<ng-template #interviewPayrateTemplate>

  <div class="common-header-flex">
    <div> Rate Confirmation </div>
    <button>
      <span (click)="hidePayrateModal()" class="common-close">&times;</span>
    </button>
  </div>

  <div class="col-sm-12 p-0 white">
    <div class="col-sm-12 p-0">

      <div [formGroup]="rtrformgrp">
        <div class="RtrForm payrate-two-row">

          <div class="payrate-row">
            <div class="payrate-row-label">Submitted for</div>
            <div class="targetRate">
              <input type="text" class="form-control input-sm payrate-readonly"
                     formControlName="submittedToRate" readonly tabindex="-1" />
            </div>
            <div class="paytype">
              <select class="form-control input-sm payrate-readonly"
                      formControlName="submittedRateType" disabled tabindex="-1">
                <option value="Hourly">Hourly</option>
                <option value="Daily">Daily</option>
                <option value="Weekly">Weekly</option>
                <option value="Monthly">Monthly</option>
                <option value="Yearly">Yearly</option>
              </select>
            </div>
          </div>

          <div class="payrate-row">
            <div class="payrate-row-label">Offer for</div>
            <div class="targetRate">
              <input maxlength="8" (keypress)="isInteger($event)" type="text"
                class="form-control input-sm" formControlName="offerRate" placeholder="Ex: 10000.."/>
              <span *ngIf="rtrFormControls.offerRate.errors?.required &&
                (rtrFormControls.offerRate?.dirty || rtrFormControls.offerRate?.touched || submitRTR)" class="error">Please enter the value</span>
              <span *ngIf="rtrFormControls.offerRate.errors?.invalidDecimal" class="error">Enter valid offer rate</span>
              <span *ngIf="rtrFormControls.offerRate.errors?.max" class="error">
                Offer cannot exceed submitted ceiling of {{ rtrformgrp.get('submittedToRate')?.value }}
              </span>
            </div>
            <div class="paytype">
              <select formControlName="offerRateType" class="form-control input-sm">
                <option value="Hourly">Hourly</option>
                <option value="Daily">Daily</option>
                <option value="Weekly">Weekly</option>
                <option value="Monthly">Monthly</option>
                <option value="Yearly">Yearly</option>
              </select>
              <span class="error" *ngIf="rtrFormControls.offerRateType.errors?.required &&
                (rtrFormControls.offerRateType?.dirty || rtrFormControls.offerRateType?.touched || submitRTR)">Please select pay type</span>
            </div>
          </div>

          <div class="currency">
            <ng-container *ngIf="pendingOfferedCandidate?.jobDetails?.source !== 'CEIPAL'; else ceipalCurOffer">
            <span *ngIf="pendingOfferedCandidate?.jobDetails?.country === 'US'"> USD </span>
            <span *ngIf="pendingOfferedCandidate?.jobDetails?.country === 'IN'"> INR </span>
            <span *ngIf="pendingOfferedCandidate?.jobDetails?.country === 'CA'"> CAD </span>
            <span *ngIf="pendingOfferedCandidate?.jobDetails?.country === 'AU'"> AUD </span>
            </ng-container>
            <ng-template #ceipalCurOffer>
              <span> {{ getJobCurrency(pendingOfferedCandidate?.jobDetails) }} </span>
            </ng-template>
          </div>

          <div class="tAndCdesign">
            <div class="custom-checkbox em">
              <label class="checkbox-label font-normal" style="text-align: center">
                I confirm the entered pay rate is accurate and approved for this candidate
                <input type="checkbox" class="termsCondition" formControlName="termsandcondition" id="interviewTermsCheckBox" />
                <span class="checkmark"></span>
              </label>
            </div>
          </div>

        </div>
        <div class="t-c-error-msg"
          *ngIf="rtrFormControls.termsandcondition.invalid && (rtrFormControls.termsandcondition.touched || submitRTR)">
          Please acknowledge the rate confirmation to proceed
        </div>
      </div>

    </div>
  </div>

  <div class="custom-panel-footer col-sm-12 p-0">
    <div class="panel-footer">
      <div class="footer-flex">
        <button class="btn btn-default " (click)="hidePayrateModal()">Cancel </button>
        <button class="btn  btn-primary " (click)="submitPayrate()"> Submit </button>
      </div>
    </div>
  </div>

</ng-template>

<app-message-widget *ngIf="messagemodelflag" (closeMessageModel)="closeMessage($event)" [messageDataPass]="messageData">
</app-message-widget>